module.exports = __webpack_public_path__ + "static/media/pizza.d44bdc80.jpg";